import * as React from 'react';
import { legacy_connect as connect } from 'react-redux';
import { actionCreators as draftActionCreators } from 'app/area/case/draft/actions';
import { contextToStorePath } from 'app/infrastructure/ui/renderer/resolvers';
import { columnName, tableName } from 'app/area/case/case-data-model';

type EgressDispatchToProps = {
  valueChanged: (storePath: any[], dataTag: string, value: any[]) => Promise<void>;
  requestImmediateSave: () => Promise<void>;
};

type EgressOwnProps = {
  componentDescriptor: { dataTag: string; entityTypePath?: string[] };
  currentUser?: { value: string | number; description?: string };
  entryLogValues?: { egressTimeRecordedBy?: { value: string | number; description?: string } };
  onChange?: (value: any) => void;
  resolveContext: { path: any[] };
};

export const withEgressValuesOnClick = (Component: any) => {
  const dispatchToProps = (dispatch: any): EgressDispatchToProps => ({
    valueChanged: async (storePath: any[], dataTag: string, value: any[]) =>
      await dispatch(draftActionCreators.valueChanged(storePath, dataTag, value)),
    requestImmediateSave: async () => await dispatch(draftActionCreators.requestImmediateSave())
  });

  const WrappedComponent = (props: EgressOwnProps & EgressDispatchToProps) => {
    const {
      requestImmediateSave,
      valueChanged,
      ...remainingProps
    } = props;

    const onToggleClick = async (value: any) => {
      const storePath = contextToStorePath(props.componentDescriptor as any, props.resolveContext as any);
      const egressValue = value === undefined ? [] : [{ value }];
      const storedRecordedBy = props.entryLogValues?.egressTimeRecordedBy;
      const recordedBy = storedRecordedBy?.value ? storedRecordedBy : props.currentUser;
      const recordedByValue = value === undefined || !recordedBy
        ? []
        : [{ value: recordedBy.value, description: recordedBy.description }];

      // Dispatch both fields together (no await in between) so React never renders an
      // intermediate state where egressTime is set but egressTimeRecordedBy is not yet -
      // that intermediate state forces readOnly=true (see case-egress-readonly.tsx), which
      // combined with the `.signed button[disabled] { display: none }` CSS rule makes the
      // toggle button disappear instead of switching to "Undo Egress".
      await Promise.all([
        valueChanged(storePath, props.componentDescriptor.dataTag, egressValue),
        valueChanged(
          storePath,
          columnName[tableName.involvedPersonInside].egressTimeRecordedBy,
          recordedByValue
        )
      ]);
      await requestImmediateSave();
    };

    return <Component {...remainingProps} onChange={onToggleClick} />;
  };

  return connect<any, any, any>(undefined, dispatchToProps)(WrappedComponent);
};
